import React from 'react';
import { Text } from '@smarterservices/smarter-ui';
import { Responsive, Table } from '@instructure/ui';
import { randomId } from '../../../helpers/utilities';
import { getStore } from '../../../stores/StoreContext';
import { formatDuration } from '../../../helpers/utilities';
const routingData = [
  {
    id: 1,
    location: 'SmarterServices Live Proctoring',
    room: 'Greeter Flow RM A',
    timeInRoom: 580,
  },
  {
    id: 2,
    location: 'SmarterServices Live Proctoring',
    room: 'Live Proctoring RM 1',
    timeInRoom: 5000,
  },
];

const RoomFlow = (props) => {
  const ExamSession = getStore('examSessionStore');
  return (
    <Responsive
      query={{
        small: { maxWidth: '100px' },
        large: { minWidth: '300px', maxWidth: '100px' },
      }}
      props={{
        small: { layout: 'stacked' },
        large: { layout: 'fixed' },
      }}
    >
      {({ layout }) => (
        <div>
          <Table caption="Room Flow History" layout="auto">
            <Table.Head>
              <Table.Row>
                <Table.ColHeader id="location-header">Location</Table.ColHeader>
                <Table.ColHeader id="room-header">Room</Table.ColHeader>
                <Table.ColHeader id="time-in-room-header">
                  Time In Room
                </Table.ColHeader>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {routingData.map((row) => (
                <Table.Row key={row.id}>
                  <Table.Cell
                    key={randomId()}
                    textAlign={layout === 'stacked' ? 'start' : 'start'}
                  >
                    <Text as="div">{row.location}</Text>
                  </Table.Cell>
                  <Table.Cell
                    key={randomId()}
                    textAlign={layout === 'stacked' ? 'start' : 'start'}
                  >
                    <Text as="div">{row.room}</Text>
                  </Table.Cell>
                  <Table.Cell
                    key={randomId()}
                    textAlign={layout === 'stacked' ? 'start' : 'start'}
                  >
                    {formatDuration(row.timeInRoom)}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      )}
    </Responsive>
  );
};

export default RoomFlow;
